import type React from 'react';
import type { DSFastListT } from '@elliemae/ds-fast-list';

import type { DSComboboxT } from './react-desc-prop-types.js';
import { MENU_OPTION_TYPES } from './constants.js';

export declare namespace DSComboboxInternalsT {
  export interface ComboBoxContextT {
    props: DSComboboxT.InternalProps;
    internalRef: React.RefObject<HTMLInputElement>;
    menuState: boolean;
    setShowPopover: React.Dispatch<React.SetStateAction<boolean>>;
    pillGroupRef: React.RefObject<HTMLDivElement>;
    scrollOptionIntoView: (dsId: string, opts: DSFastListT.ScrollToOptions) => void;
    setHasFocus: React.Dispatch<React.SetStateAction<boolean>>;
    hasFocus: boolean;
    listRef: React.MutableRefObject<DSComboboxT.ActionRefVirtualized>;
    wrapperListRef: React.RefObject<HTMLDivElement>;
    inputValue: string;
    setInputValue: React.Dispatch<React.SetStateAction<string>>;
    selectedOptionsRef: React.RefObject<HTMLDivElement>;
    controlsWrapperRef: React.RefObject<HTMLDivElement>;
    focusOptionIdx: string;
    setFocusOptionIdx: React.Dispatch<React.SetStateAction<string>>;
    setMenuState: (
      newState: boolean,
      reason: string,
      e?: React.KeyboardEvent | React.MouseEvent | React.ChangeEvent<HTMLInputElement>,
    ) => void;
    correctOptions: DSComboboxT.OptionTypes[];
    instanceUid: string;
    optionsPerSection: DSComboboxT.OptionTypes[];
    shouldPreventContextMenuOpening: boolean;
  }
}

export const isSeparator = (el: DSComboboxT.OptionTypes | undefined): el is DSComboboxT.ItemSeparatorOptions =>
  el?.type === MENU_OPTION_TYPES.SEPARATOR;

export const isOption = (el: DSComboboxT.OptionTypes | undefined): el is DSComboboxT.ItemOption =>
  el?.type === MENU_OPTION_TYPES.OPTION;
